import "./ClinicalScores.scss";
import moment from "moment";
import { useEffect, useState } from "react";
import { CHART_OPTIONS } from "../../../common/constant/common-constants";
import { CHART_CONST } from "../../../common/constant/page-constants";
import clinicalScoreInfoIcon from "../../../common/icons/svg/clinical-scores-info.svg";
import redRating from "../../../common/icons/svg/red-rating.svg";
import yellowRating from "../../../common/icons/svg/yellow-rating.svg";
import greenRating from "../../../common/icons/svg/green-rating.svg";

export function ClinicalScores(props) {
    const [headerList, setHeaderList] = useState(props.headerList);
    const [parameterList, setParameterList] = useState(props.parameterList);
    const [infoModalType, setInfoModalType] = useState(false);
    const [data, setData] = useState([]);
    const [latestGCSScore, setLatestGCSScore] = useState("");
    const [latestGCSScoreUpdatedAt, setLatestGCSScoreUpdatedAt] = useState("");
    const [latestGCSScoreUpdatedByUser, setLatestGCSScoreUpdatedByUser] = useState("");
    const [latestSofaScore, setLatestSofaScore] = useState("");
    const [latestSofaScoreUpdatedAt, setLatestSofaScoreUpdatedAt] = useState("");
    const [latestSofaScoreUpdatedByUser, setLatestSofaScoreUpdatedByUser] = useState("");
    const [latestApache2Score, setLatestApache2Score] = useState("");
    const [latestApache2ScoreUpdatedAt, setLatestApache2ScoreUpdatedAt] = useState("");
    const [latestApache2ScoreUpdatedByUser, setLatestApache2ScoreUpdatedByUser] = useState("");
    const [latestBradenScore, setLatestBradenScore] = useState("");
    const [latestBradenScoreUpdatedAt, setLatestBradenScoreUpdatedAt] = useState("");
    const [latestBradenScoreUpdatedByUser, setLatestBradenScoreUpdatedByUser] = useState("");
    const [latestFallRiskScore, setLatestFallRiskScore] = useState("");
    const [latestFallRiskScoreUpdatedAt, setLatestFallRiskScoreUpdatedAt] = useState("");
    const [latestFallRiskScoreUpdatedByUser, setLatestFallRiskScoreUpdatedByUser] = useState("");
    const [latestRASSScore, setLatestRASSScore] = useState("");
    const [latestRASSScoreUpdatedAt, setLatestRASSScoreUpdatedAt] = useState("");
    const [latestRASSScoreUpdatedByUser, setLatestRASSScoreUpdatedByUser] = useState("");


    useEffect(() => {
        setHeaderList([...props.headerList]);
        setParameterList([...props.parameterList]);

        if (props.data) {
            let clinicalScoreData = props.data;
            // console.log("data", props.data)
            setData(clinicalScoreData.data);
            setLatestGCSScore(clinicalScoreData.latestGCSScore);
            setLatestGCSScoreUpdatedAt(clinicalScoreData.latestGCSScoreUpdatedAt);
            setLatestGCSScoreUpdatedByUser(clinicalScoreData.latestGCSScoreUpdatedByUser);
            setLatestSofaScore(clinicalScoreData.latestSofaScore);
            setLatestSofaScoreUpdatedAt(clinicalScoreData.latestSofaScoreUpdatedAt);
            setLatestSofaScoreUpdatedByUser(clinicalScoreData.latestSofaScoreUpdatedByUser);
            setLatestApache2Score(clinicalScoreData.latestApache2Score);
            setLatestApache2ScoreUpdatedAt(clinicalScoreData.latestApache2ScoreUpdatedAt);
            setLatestApache2ScoreUpdatedByUser(clinicalScoreData.latestApache2ScoreUpdatedByUser);
            setLatestBradenScore(clinicalScoreData.latestBradenScore);
            setLatestBradenScoreUpdatedAt(clinicalScoreData.latestBradenScoreUpdatedAt);
            setLatestBradenScoreUpdatedByUser(clinicalScoreData.latestBradenScoreUpdatedByUser);
            setLatestRASSScore(clinicalScoreData.latestRASSScore);
            setLatestRASSScoreUpdatedAt(clinicalScoreData.latestRASSScoreUpdatedAt);
            setLatestRASSScoreUpdatedByUser(clinicalScoreData.latestRASSScoreUpdatedByUser);
            setLatestFallRiskScore(clinicalScoreData.latestFallRiskScore);
            setLatestFallRiskScoreUpdatedAt(clinicalScoreData.latestFallRiskScoreUpdatedAt);
            setLatestFallRiskScoreUpdatedByUser(clinicalScoreData.latestFallRiskScoreUpdatedByUser);
        }
    }, [props]);

    const handleChange = (type, id, key, event) => {

        let header = id;
        if (headerList.indexOf(id) > -1) {
            header = id;
            id = CHART_CONST.NEW_ID_PRED + id;
            console.log(id);
        }
        let value = event && event.target && event.target.value;

        if (value === "on") value = event.target.checked;

        if (value === undefined) return;

        // props.handleDataChange(id, header, key, value);
    }
    const handleInfoClick = (label) => {
        setInfoModalType(label);
        if (infoModalType) {
            setInfoModalType("");
        }
    }

    const getHtml = () => {

        let html = headerList && headerList.map((header, count) => {
            let headerTime = moment(header, "HH:mm");
            let currentTime = moment(new Date(), "HH:mm");

            if (count === 0) {
                return (
                    <div className="column col-parameters" key={header}>
                        <div className="first-column-width heading param">{header}</div>
                        {parameterList.map((param) => {
                            // console.log("param", param);
                            return (
                                <div className="clinical-score-cell param" key={param.label}>
                                    <div className="cell-param-header" key={param.label}>
                                        <div className="cell-label">{param.label}</div>
                                        <img src={clinicalScoreInfoIcon} className="info-icon" onClick={() => handleInfoClick(param.label)} />
                                        {infoModalType === "SOFA" &&
                                            <div className="sofa-info-score-container default-container">
                                                <div className="common-info-content">
                                                    <div className="common-modal">
                                                        <img src={redRating} />
                                                        <span>High Risk: {'>'}11</span>
                                                    </div>
                                                    <div className="common-modal">
                                                        <img src={yellowRating} />
                                                        <span>Mid Risk: 8 - 11</span>
                                                    </div>
                                                    <div className="common-modal">
                                                        <img src={greenRating} />
                                                        <span>Low Risk: 0 - 8</span>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {infoModalType === "GCS" &&
                                            <div className="gcs-info-score-container default-container">
                                                <div className="common-info-content">
                                                    <div className="common-modal">
                                                        <img src={redRating} />
                                                        <span>High Risk: 0 - 8</span>
                                                    </div>
                                                    <div className="common-modal">
                                                        <img src={yellowRating} />
                                                        <span>Mid Risk: 9 - 12</span>
                                                    </div>
                                                    <div className="common-modal">
                                                        <img src={greenRating} />
                                                        <span>Low Risk: 13 - 15</span>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {infoModalType === "Braden" &&
                                            <div className="braden-info-score-container default-container">
                                                <div className="common-info-content">
                                                    <div className="common-modal">
                                                        <img src={redRating} />
                                                        <span>High Risk: 9 - 12</span>
                                                    </div>
                                                    <div className="common-modal">
                                                        <img src={yellowRating} />
                                                        <span>Mid Risk: 13 - 18</span>
                                                    </div>
                                                    <div className="common-modal">
                                                        <img src={greenRating} />
                                                        <span>Low Risk: 15 - 23</span>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {infoModalType === "Risk Fall" &&
                                            <div className="fall-risk-info-score-container default-container">
                                                <div className="common-info-content">
                                                    <div className="common-modal">
                                                        <img src={redRating} />
                                                        <span>High Risk: 50+</span>
                                                    </div>
                                                    <div className="common-modal">
                                                        <img src={yellowRating} />
                                                        <span>Mid Risk: 1 - 50</span>
                                                    </div>
                                                    <div className="common-modal">
                                                        <img src={greenRating} />
                                                        <span>Low Risk: 0</span>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {infoModalType === "Apache II" &&
                                            <div className="apache-2-info-score-container default-container">
                                                <div className="common-info-content">
                                                    <div className="common-modal">
                                                        <img src={redRating} />
                                                        <span>High Risk: 29+</span>
                                                    </div>
                                                    <div className="common-modal">
                                                        <img src={yellowRating} />
                                                        <span>Mid Risk: 10 - 29</span>
                                                    </div>
                                                    <div className="common-modal">
                                                        <img src={greenRating} />
                                                        <span>Low Risk: 0 - 9</span>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {infoModalType === "RASS" &&
                                            <div className="rass-info-score-container default-container">
                                                <div className="common-info-content">
                                                    <div className="common-modal">
                                                        <img src={redRating} />
                                                        <span>High Risk: -4 to -2 and 2 to 4</span>
                                                    </div>
                                                    <div className="common-modal">
                                                        <img src={yellowRating} />
                                                        <span>Mid Risk: -1 and 1</span>
                                                    </div>
                                                    <div className="common-modal">
                                                        <img src={greenRating} />
                                                        <span>Low Risk: 0</span>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {param && param.label === "GCS" && <div className={`show-score
                                            ${latestGCSScore !== null ? (latestGCSScore <= "8" ? "red-score" : "") : "default-color"}
                                        ${(latestGCSScore !== null ? (latestGCSScore <= "12") && (latestGCSScore >= "9") ? "yellow-score" : "" : "default-color")}
                                        ${latestGCSScore !== null ? (latestGCSScore > '12' ? "green-score" : "") : "default-color"}`}
                                        >
                                            Score: {latestGCSScore}
                                        </div>}
                                        {param && param.label === "SOFA" && <div className={`show-score
                                            ${latestSofaScore !== null ? (latestSofaScore > "11" ? "red-score" : "") : "default-color"}
                                        ${latestSofaScore !== null ? ((latestSofaScore >= "8") && (latestSofaScore <= "11") ? "yellow-score" : "") : "default-color"}
                                        ${latestSofaScore !== null ? (latestSofaScore < '8' ? "green-score" : "") : "default-color"}`}
                                        >
                                            Score: {latestSofaScore}
                                        </div>}
                                        {param && param.label === "RASS" && <div className={`show-score
                                            ${latestRASSScore !== null ? ((((latestRASSScore >= "-5") && (latestRASSScore <= "-2")) || ((latestRASSScore >= "2") && (latestRASSScore <= "4"))) ? "red-score" : "") : "default-color"}
                                        ${latestRASSScore !== null ? ((latestRASSScore == "-1") || (latestRASSScore == "1") ? "yellow-score" : "") : "default-color"}
                                        ${latestRASSScore !== null ? (latestRASSScore === 0 ? "green-score" : "") : "default-color"}`}
                                        >
                                            Score: {latestRASSScore}
                                        </div>}
                                        {param && param.label === "Braden" && <div className={`show-score
                                            ${latestBradenScore !== null ? ((latestBradenScore <= "12") ? "red-score" : "") : "default-color"}
                                        ${latestBradenScore !== null ? ((latestBradenScore >= "13") && (latestBradenScore <= "18") ? "yellow-score" : "") : "default-color"}
                                        ${latestBradenScore !== null ? ((latestBradenScore >= "19") && (latestBradenScore <= "23") ? "green-score" : "") : "default-color"}`}
                                        >
                                            Score: {latestBradenScore}
                                        </div>}
                                        {param && param.label === "Risk Fall" && <div className={`show-score
                                            ${latestFallRiskScore !== null ? (latestFallRiskScore > "45" ? "red-score" : "") : "default-color"}
                                        ${latestFallRiskScore !== null ? ((latestFallRiskScore >= "25") && (latestFallRiskScore <= "45") ? "yellow-score" : "") : "default-color"}
                                        ${latestFallRiskScore !== null ? (latestFallRiskScore < '25' ? "green-score" : "") : "default-color"}`}
                                        >
                                            Score: {latestFallRiskScore}
                                        </div>}
                                        {param && param.label === "Apache II" && <div className={`show-score
                                            ${latestApache2Score !== null ? (latestApache2Score > "29" ? "red-score" : "") : "default-color"}
                                        ${latestApache2Score !== null ? ((latestApache2Score >= "10") && (latestApache2Score <= "29") ? "yellow-score" : "") : "default-color"}
                                        ${latestApache2Score !== null ? (latestApache2Score < '10' ? "green-score" : "") : "default-color"}`}
                                        >
                                            Score: {latestApache2Score}
                                        </div>}
                                    </div>
                                    {param && param.label === "GCS" ? latestGCSScore !== null ?
                                        <span className="update-info">Updated at {moment(latestGCSScoreUpdatedAt).format("HH:mm")} by {latestGCSScoreUpdatedByUser && latestGCSScoreUpdatedByUser.role}. {latestGCSScoreUpdatedByUser && latestGCSScoreUpdatedByUser.name}.({latestGCSScoreUpdatedByUser && latestGCSScoreUpdatedByUser.id})</span> :
                                        <span>No updates yet!</span> : ""}
                                    {param && param.label === "SOFA" ? latestSofaScore !== null ?
                                        <span className="update-info">Updated at {moment(latestSofaScoreUpdatedAt).format("HH:mm")} by {latestSofaScoreUpdatedByUser && latestSofaScoreUpdatedByUser.role}. {latestSofaScoreUpdatedByUser && latestSofaScoreUpdatedByUser.name}.({latestSofaScoreUpdatedByUser && latestSofaScoreUpdatedByUser.id})</span> :
                                        <span>No updates yet!</span> : ""}
                                    {param && param.label === "RASS" ? latestRASSScore !== null ?
                                        <span className="update-info">Updated at {moment(latestRASSScoreUpdatedAt).format("HH:mm")} by {latestRASSScoreUpdatedByUser && latestRASSScoreUpdatedByUser.role}. {latestRASSScoreUpdatedByUser && latestRASSScoreUpdatedByUser.name}.({latestRASSScoreUpdatedByUser && latestRASSScoreUpdatedByUser.id})</span> :
                                        <span>No updates yet!</span> : ""}
                                    {param && param.label === "Risk Fall" ? latestFallRiskScore !== null ?
                                        <span className="update-info">Updated at {moment(latestFallRiskScoreUpdatedAt).format("HH:mm")} by {latestFallRiskScoreUpdatedByUser && latestFallRiskScoreUpdatedByUser.role}. {latestFallRiskScoreUpdatedByUser && latestFallRiskScoreUpdatedByUser.name}.({latestFallRiskScoreUpdatedByUser && latestFallRiskScoreUpdatedByUser.id})</span> :
                                        <span>No updates yet!</span> : ""}
                                    {param && param.label === "Apache II" ? latestApache2Score !== null ?
                                        <span className="update-info">Updated at {moment(latestApache2ScoreUpdatedAt).format("HH:mm")} by {latestApache2ScoreUpdatedByUser && latestApache2ScoreUpdatedByUser.role}. {latestApache2ScoreUpdatedByUser && latestApache2ScoreUpdatedByUser.name}.({latestApache2ScoreUpdatedByUser && latestApache2ScoreUpdatedByUser.id})</span> :
                                        <span>No updates yet!</span> : ""}
                                    {param && param.label === "Braden" ? latestBradenScore !== null ?
                                        <span className="update-info">Updated at {moment(latestBradenScoreUpdatedAt).format("HH:mm")} by {latestBradenScoreUpdatedByUser && latestBradenScoreUpdatedByUser.role}. {latestBradenScoreUpdatedByUser && latestBradenScoreUpdatedByUser.name}.({latestBradenScoreUpdatedByUser && latestBradenScoreUpdatedByUser.id})</span> :
                                        <span>No updates yet!</span> : ""}
                                </div>
                            )
                        })
                        }
                    </div >
                )
            } else {

                let col = data && data.length > 0 && data.filter((obj) => moment(obj.time, "hh:mm").isSame(headerTime))[0];

                return (
                    <div className="column" key={header}>
                        <div className=" cell-width heading" key={header}>{header}</div>
                        {parameterList.map((param) => {
                            return (
                                <div className="clinical-score-cell body" key={param.name}>
                                    <input
                                        className="chart-input"
                                        value={col && col[param.name] !== null ? col[param.name] : ""}
                                        readOnly={true}
                                    />
                                </div>
                            );
                        })}
                    </div>
                );
            }
        })
        return html;
    }


    return (
        <div className="table-clinical-score">
            {getHtml()}
        </div>
    );
}